import { RouteResponse } from "@0xsquid/squid-types";
import { DEFAULT_ROUTE_REFETCH_INTERVAL } from "../../core/constants";
import { isOnChainTxData } from "./transactionService";

/**
 * Return the expiry of a route in milliseconds
 *
 * @param route - Squid route
 * @returns expiry in milliseconds
 */
export function getRouteExpiry(
  route: RouteResponse["route"] | undefined
): number {
  if (!route?.transactionRequest) return DEFAULT_ROUTE_REFETCH_INTERVAL;

  if (!isOnChainTxData(route.transactionRequest)) {
    return DEFAULT_ROUTE_REFETCH_INTERVAL;
  }

  const { expiryOffset } = route.transactionRequest;

  if (expiryOffset != null && Number(expiryOffset) >= 0) {
    return Number(expiryOffset) * 1_000;
  }

  return DEFAULT_ROUTE_REFETCH_INTERVAL;
}
